<!--<div class="orientation-video-heading">-->
  <!--  {{ 'student.orientationVideo.uniPrepSession' | translate }}-->
  <!--</div>-->

<!--<div *ngIf="orientationVideos?.items?.length > 0">-->
<!--    <div class="orientation-video" *ngFor="let videos of orientationVideos.items">-->
<!--        <iframe [src]="videos.media_url" width="560" height="315" frameborder="0" webkitallowfullscreen-->
<!--            mozallowfullscreen allowfullscreen></iframe>-->
<!--    </div>-->
<!--</div>-->
<!--<div class="orientation-video">-->
<!--    <iframe-->
<!--        src="https://www.loom.com/embed/6f6aa9a5060f469484baadce42c38787" frameborder="0" webkitallowfullscreen-->
<!--        mozallowfullscreen allowfullscreen>-->
<!--    </iframe>-->
<!--</div>-->

<!--<div class="orientation-video-heading">-->
<!--  {{ 'student.orientationVideo.examBoost' | translate }}-->
<!--</div>-->

<!--<div class="orientation-video">-->
<!--  <iframe-->
<!--    src="https://www.loom.com/embed/2f53b92bf39047ffac1a90a51c7e7432" frameborder="0" webkitallowfullscreen-->
<!--    mozallowfullscreen allowfullscreen>-->
<!--  </iframe>-->
<!--</div>-->

<div class="curr-orientation-video">
  <div class="orientation-video-section" *currHasRoles="[userRole.Student]">
    <div class="orientation-video-section-title">
      {{ 'student.orientationVideo.takingTest' | translate }}
    </div>
    <div class="orientation-video">
      <iframe
        src="https://www.loom.com/embed/f04448b173a942c4b29003f6659df264?sid=a08be666-acc0-4f38-9137-86ca83852e2f&hideEmbedTopBar=true"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen>
      </iframe>
    </div>
  </div>


  <div class="orientation-video-section" *currHasRoles="[userRole.Teacher]">
    <div class="orientation-video-section-title">Welcome!</div>

    <div class="section">
      <p>
        Curriculum.com is designed to save you time and make teaching more effective. It streamlines the process
        of setting work, marking, and providing feedback, while giving you deeper insights into both class-wide
        and individual student progress. It also serves as a central hub for all your teaching materials, from
        student handouts to question banks, making it quick and easy to retrieve, update, and reuse resources.
      </p>
      <p>View “Teacher Overview” video <a href="https://youtu.be/-6l_YDxu2t0?si=sMt259kuiAX62Q9t" target="_blank" class="video-link">HERE</a></p>
    </div>

    <div class="section">
      <div class="section-title">2. Getting Started</div>
      <div class="section-subtitle">2.1 Signing In</div>
      <ul>
        <li>Go to <a href="https://was.curriculum.com/" target="_blank" class="video-link">WAS.curriculum.com</a></li>
        <li>Enter your school provided email address. An access code will be shared to your email, please use that where propeded to to access the platform.</li>
      </ul>
      <p><a href="https://www.loom.com/share/acf8ac469b894c2c8bef7d267f4c1f6e?sid=0a6f44f9-e8bc-4dbe-bcc9-46eadd45ccf4" target="_blank" class="video-link">How to sign in and sign out</a></p>
    </div>

    <div class="section">
      <div class="section-subtitle">2.2 Creating & Managing Classes</div>
      <p>Class/Course/Form setup <a href="https://www.loom.com/share/8863678a2e70468c99802164bb7fb83d?sid=98a068e8-4d49-43a1-b747-ef997b94c407" target="_blank" class="video-link">How to</a></p>

      <p>Before creating a class/ course/ set in the system, the Scheme of Work you plan to use must already exist and be available.</p>
      <p>When setting up your course, you will be asked to select a Scheme of Work from the “Select Scheme of Work” drop-down list.</p>
      <ul>
        <li>If your subject does not appear, wait until your Subject Head publishes it.</li>
        <li>Once published, you can proceed with creating your course.</li>
      </ul>

      <p><span class="section-bold">Important:</span> When setting up your course, the Course ID you enter must exactly match the SET ID stored in iSAMS.</p>

      <ul>
        <li>Building out the class
          <ul>
            <li><a href="https://www.loom.com/share/5c16ce79d8c543e8b3a54f35aac23b8f?sid=6433ae03-8fe1-4ed3-93bc-13b99bf89792" target="_blank" class="video-link">Creating</a> Topics
              <ul>
                <li>Updating and <a href="https://www.loom.com/share/a0a23a601e6b4571a7f1a194d47aa677?sid=ddfab92c-bef4-443e-bf17-29f31e70ee92" target="_blank" class="video-link">reordering</a> topics</li>
              </ul>
            </li>
            <li>Adding Resources
              <ul>
                <li>Scheme of <a href="https://www.loom.com/share/5bfed525840a4d63b7f3563cb7f70a68?sid=590f2e8d-5abf-4b18-8db1-258571759d52" target="_blank" class="video-link">Work</a></li>
                <li>Populating the question bank
                  <ul>
                    <li><a href="https://www.loom.com/share/0c25008597014784b76724e3a6fe2998?sid=d61e5284-0109-4dc2-9acc-c8267489ef11" target="_blank" class="video-link">Manula</a></li>
                    <li><a href="https://www.loom.com/share/480d000ce37a4d8692fdfd3f6c1f2b35?sid=ca51b116-6bf7-434a-8099-43890f23782b" target="_blank" class="video-link">AI</a> Assisted</li>
                  </ul>
                </li>
                <li>Adding a <a href="https://www.loom.com/share/649d26213f9a48698914477f7874dd9d?sid=37df19a4-1636-44fa-952a-1bdd8fd55aea" target="_blank" class="video-link">lesson plan</a></li>
                <li>Teacher <a href="https://www.loom.com/share/84296493befe4e348eec4e00dcb40ebc?sid=d738d799-6247-472d-b199-dc1db69f4502" target="_blank" class="video-link">Guidance</a></li>
                <li>Student <a href="https://www.loom.com/share/6d8bad06c0e94159b5658e5566902ced?sid=3efef752-126d-44d2-a33b-1ac780aa9ecf" target="_blank" class="video-link">Handouts</a></li>
                <li>Student <a href="https://www.loom.com/share/24e7ff48bfe84bb39518ea03245ea3c2?sid=3e75aca7-3b45-446d-893f-b625c4fd4137" target="_blank" class="video-link">Resource</a></li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="section">
      <div class="section-subtitle">2.3 Setting and Marking Student Work</div>

      <ul>
        <li>Navigating the Teacher <a href="https://www.loom.com/share/b72b7b1d43f64bd6b2b21ec7f53368f5?sid=fbf9ce3e-e041-46a5-83ad-61dd52eb42da" target="_blank" class="video-link">Homepage</a>
          <ul>
            <li><a target="_blank" href="https://www.loom.com/share/37b149d0a5ae4a9a89558e925729bd05?sid=0bb7f1e0-ae4d-4292-8823-a969e1953fef" class="video-link">Setting</a> homework / quizzes and cumulative tests
              <ul>
                <li><a target="_blank" href="https://www.loom.com/share/2b2ed33649584706b6fbdd741cc952ee?sid=0f059387-07b8-431e-8552-d4f546c13582" class="video-link">Reviewing</a> and marking of student submitted work</li>
                <li>The Student <a target="_blank" href="https://www.loom.com/share/53ba2c6b0b7140178f89c8ce353e9e95?sid=c4a108bb-547a-4a30-b52f-bc6bc31602ce" class="video-link">homepage</a> / classes and resources</li>
                <li>As a Student <a target="_blank" href="https://www.loom.com/share/ad67f2112ae3481b92b0b74180020678?sid=94c8fe25-44f8-4201-a066-2c9dbd0b7bac" class="video-link">responding</a> to the assigned work</li>
                <li>Receiving <a target="_blank" href="https://www.loom.com/share/466f659924694968a5d33ff46514a450?sid=4ec9a9d8-918e-4d76-b409-91b0af18a1f2" class="video-link">feedback</a></li>
              </ul>
            </li>
          </ul>
        </li>
        <li>Changing platform <a target="_blank" href="https://www.loom.com/share/cf538e8ea15f40bfbf29252128db2c55?sid=c08ac1b3-946c-4b0e-8d14-666d0f10e022" class="video-link">language</a> between English and Chinese</li>
      </ul>
    </div>

    <div class="checklist-section">
      <div class="section-title">3. Teacher Checklist</div>

      <div class="subsection-title">✅ Setup</div>
      <ul>
        <li>Sign in & update profile</li>
        <li>Create classes (ensure correct Class ID is used)</li>
        <li>Check topics match the Scheme of Work</li>
      </ul>

      <div class="subsection-title">✅ Resources</div>
      <ul>
        <li>Upload Teacher Guidance & Lesson Plans</li>
        <li>Upload Student Resources</li>
      </ul>

      <div class="subsection-title">✅ Assignments</div>
      <ul>
        <li>Set student work</li>
        <li>Choose AI or Student self-mark</li>
        <li>Release results within X days</li>
      </ul>

      <div class="subsection-title">✅ Ongoing</div>
      <ul>
        <li>Review dashboards weekly</li>
      </ul>
    </div>
  </div>


  <div class="orientation-video-section" *currHasRoles="[userRole.SchoolAdmin]">
    <div class="orientation-video-section-title">Welcome!</div>

    <div class="section">
      <p>Curriculum.com enables school leadership to:</p>
      <ul>
        <li>Standardise teaching quality.</li>
        <li>Monitor teacher usage and student performance.</li>
        <li>Ensure consistent resource delivery across all classes.</li>
      </ul>
      <p>View “Teacher Overview” video <a href="https://youtu.be/-6l_YDxu2t0?si=sMt259kuiAX62Q9t" target="_blank" class="video-link">HERE</a></p>
      <p>Administrator Overview” video <a href="https://youtu.be/_-Vm8toLPgw?si=8xRb8wILDhSTLE7v" target="_blank" class="video-link">HERE</a></p>
    </div>

    <div class="section">
      <div class="section-title">2. Getting Started</div>
      <div class="section-subtitle">2.1 Signing In</div>
      <ul>
        <li>Go to <a href="https://was.curriculum.com/" target="_blank" class="video-link">WAS.curriculum.com</a></li>
        <li>Enter your school provided email address. An access code will be shared to your email, please use that where propeded to to access the platform.</li>
      </ul>
      <p><a href="https://www.loom.com/share/acf8ac469b894c2c8bef7d267f4c1f6e?sid=0a6f44f9-e8bc-4dbe-bcc9-46eadd45ccf4" target="_blank" class="video-link">How to sign in and sign out</a></p>
    </div>

    <div class="section">
      <div class="section-subtitle">2.2 Setting Up Subjects</div>

      <p>Before teachers can create a class, course, or set in the system, the Subject must first be set up and published by the Subject Head.</p>
      <p>As Subject Head, your responsibility is to:</p>
      <ul>
        <li>Create and publish the Scheme of Work for your subject.</li>
        <li>Ensure that the Scheme of Work includes at a minimum the topic list for the Subject. At any potential you can continue to add the relevant topics and linked resources for teachers to use. However, you must publish the subject before teachers are able to begin adding their own materials and resources to complement what the school makes available to them.</li>
      </ul>

      <p>Once your subject has been published, it will appear in the “Select Scheme of Work” drop-down list for your teachers to select from when creating their course. Only then will teachers be able to create their courses.</p>

      <p><span class="section-bold">Important:</span> Teachers will need to enter a Course ID that exactly matches the SET ID stored in iSAMS when setting up their course.</p>

      <ul>
        <li><a href="https://www.loom.com/share/fab7830f8e514fec95be2b7d946f6b35?sid=97d78b50-f763-40ce-b563-9a3f8eb7ddd1" target="_blank" class="video-link">Create</a> subjects with resources
          <ul>
            <li><a href="https://www.loom.com/share/5c16ce79d8c543e8b3a54f35aac23b8f?sid=6433ae03-8fe1-4ed3-93bc-13b99bf89792" target="_blank" class="video-link">Creating</a> Topics
              <ul>
                <li>Updating and <a href="https://www.loom.com/share/a0a23a601e6b4571a7f1a194d47aa677?sid=ddfab92c-bef4-443e-bf17-29f31e70ee92" target="_blank" class="video-link">reordering</a> topics</li>
              </ul>
            </li>
            <li>Adding Resources
              <ul>
                <li>Scheme of <a href="https://www.loom.com/share/5bfed525840a4d63b7f3563cb7f70a68?sid=590f2e8d-5abf-4b18-8db1-258571759d52" target="_blank" class="video-link">Work</a></li>
                <li>Populating the question bank
                  <ul>
                    <li><a href="https://www.loom.com/share/0c25008597014784b76724e3a6fe2998?sid=d61e5284-0109-4dc2-9acc-c8267489ef11" target="_blank" class="video-link">Manula</a></li>
                    <li><a href="https://www.loom.com/share/480d000ce37a4d8692fdfd3f6c1f2b35?sid=ca51b116-6bf7-434a-8099-43890f23782b" target="_blank" class="video-link">AI</a> Assisted</li>
                  </ul>
                </li>
                <li>Adding a <a href="https://www.loom.com/share/649d26213f9a48698914477f7874dd9d?sid=37df19a4-1636-44fa-952a-1bdd8fd55aea" target="_blank" class="video-link">lesson plan</a></li>
                <li>Teacher <a href="https://www.loom.com/share/84296493befe4e348eec4e00dcb40ebc?sid=d738d799-6247-472d-b199-dc1db69f4502" target="_blank" class="video-link">Guidance</a></li>
                <li>Student <a href="https://www.loom.com/share/6d8bad06c0e94159b5658e5566902ced?sid=3efef752-126d-44d2-a33b-1ac780aa9ecf" target="_blank" class="video-link">Handouts</a></li>
                <li>Student <a href="https://www.loom.com/share/24e7ff48bfe84bb39518ea03245ea3c2?sid=3e75aca7-3b45-446d-893f-b625c4fd4137" target="_blank" class="video-link">Resource</a></li>
              </ul>
            </li>
          </ul>
        </li>
        <li>Class/ Course/ Form setup. <a href="https://www.loom.com/share/8863678a2e70468c99802164bb7fb83d?sid=98a068e8-4d49-43a1-b747-ef997b94c407" target="_blank" class="video-link">How to</a></li>
      </ul>
    </div>

    <div class="section">
      <div class="section-subtitle">2.3 Administrator Dashboard</div>
      <p><a href="https://www.loom.com/share/bdb6e9840b66444f85f50538392b4ffe?sid=a8501bb6-e5c5-4ec8-84f1-6c20baefa162" target="_blank" class="video-link">Interpret</a> homepage metrics and drilling down into specific subjects or students.</p>
    </div>

    <div class="section">
      <div class="section-subtitle">2.4 As a teacher</div>
      <ul>
        <li>Navigating the Teacher <a href="https://www.loom.com/share/b72b7b1d43f64bd6b2b21ec7f53368f5?sid=fbf9ce3e-e041-46a5-83ad-61dd52eb42da" target="_blank" class="video-link">Homepage</a>
          <ul>
            <li><a href="https://www.loom.com/share/37b149d0a5ae4a9a89558e925729bd05?sid=0bb7f1e0-ae4d-4292-8823-a969e1953fef" target="_blank" class="video-link">Setting</a> homework / quizzes and cumulative tests
              <ul>
                <li><a href="https://www.loom.com/share/2b2ed33649584706b6fbdd741cc952ee?sid=0f059387-07b8-431e-8552-d4f546c13582" target="_blank" class="video-link">Reviewing</a> and marking of student submitted work</li>
                <li>The Student <a href="https://www.loom.com/share/53ba2c6b0b7140178f89c8ce353e9e95?sid=c4a108bb-547a-4a30-b52f-bc6bc31602ce" target="_blank" class="video-link">homepage</a> / classes and resources</li>
                <li>As a Student <a href="https://www.loom.com/share/ad67f2112ae3481b92b0b74180020678?sid=94c8fe25-44f8-4201-a066-2c9dbd0b7bac" target="_blank" class="video-link">responding</a> to the assigned work</li>
                <li>Receiving <a href="https://www.loom.com/share/466f659924694968a5d33ff46514a450?sid=4ec9a9d8-918e-4d76-b409-91b0af18a1f2" target="_blank" class="video-link">feedback</a></li>
                <li>Changing platform <a href="https://www.loom.com/share/cf538e8ea15f40bfbf29252128db2c55?sid=c08ac1b3-946c-4b0e-8d14-666d0f10e022" target="_blank" class="video-link">language</a> between English and Chinese</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="section">
      <div class="section-title">3. Best Practices & Expectations</div>
      <ul>
        <li>Maintain up-to-date benchmark resources for every subject.</li>
        <li>Monitor teacher usage <span class="section-bold">weekly</span>.</li>
        <li>Provide support and retraining where needed.</li>
        <li>Use dashboard insights for decision-making.</li>
      </ul>
    </div>

    <div class="checklist-section">
      <div class="section-title">4. Administrator Checklist</div>

      <div class="subsection-title">✅ Setup</div>
      <ul>
        <li>Create subjects with benchmark resources</li>
        <li>Create teacher accounts</li>
      </ul>

      <div class="subsection-title">✅ Training</div>
      <ul>
        <li>Share guides & videos with staff</li>
        <li>Deliver onboarding sessions</li>
      </ul>

      <div class="subsection-title">✅ Monitoring</div>
      <ul>
        <li>Review dashboard weekly</li>
        <li>Generate monthly usage & progress reports</li>
        <li>Support staff as needed</li>
      </ul>
    </div>
  </div>
</div>
